import { render, staticRenderFns } from "./UsersComponent.vue?vue&type=template&id=5f827a63&scoped=true"
import script from "./UsersComponent.vue?vue&type=script&lang=js"
export * from "./UsersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f827a63",
  null
  
)

export default component.exports